<div class="h-full p-8">
  <!-- Header -->
  <div class="mb-5">
    <app-page-header
      title="Administración de Usuarios"
      subtitle="Gestiona los usuarios y sus chatbots asociados"
    >
      <ng-template #headerAction>
        <button 
            mat-raised-button 
            color="primary"
            (click)="openCreateModal()"
            class="flex items-center gap-2 !bg-light-primary dark:!bg-dark-primary !text-white hover:!bg-light-primary-variant dark:hover:!bg-dark-primary-variant !rounded-xl !px-6 !py-5 !shadow-soft hover:!shadow-medium transition-all duration-200">
            <lucide-angular [img]="Plus" class="w-5 h-5"></lucide-angular>
            Nuevo Usuario
        </button>
      </ng-template>
    </app-page-header>
  </div>

  <!-- Generic Data Table -->
  <app-data-table
    [data]="filteredUsers()"
    [columns]="tableColumns"
    [actions]="tableActions"
    [loading]="loading()"
    [config]="tableConfig"
    [searchFunction]="searchFunction"
    tableCaption="Lista de usuarios con sus chatbots asignados">

    <!-- Custom Filters Template -->
    <ng-template #customFilters>
      <mat-checkbox 
        [checked]="activeOnly()"
        (change)="activeOnly.set($event.checked)"
        color="primary"
        class="ml-4 mb-4">
        Solo activos
      </mat-checkbox>
    </ng-template>
  </app-data-table>
</div>
